var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCtaArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.25781L11.9922 1.42188C11.9922 1.11979 11.8984 0.875 11.7109 0.6875C11.5286 0.494792 11.2786 0.398438 10.9609 0.398438H3.125C2.83854 0.398438 2.59896 0.494792 2.40625 0.6875C2.21875 0.875 2.125 1.09896 2.125 1.35938C2.125 1.61979 2.22135 1.84115 2.41406 2.02344C2.61198 2.20573 2.84375 2.29688 3.10938 2.29688H5.9375L8.96875 2.1875L7.57031 3.42188L0.359375 10.6484C0.145833 10.862 0.0390625 11.099 0.0390625 11.3594C0.0390625 11.526 0.0859375 11.6875 0.179688 11.8438C0.273438 11.9948 0.393229 12.1172 0.539062 12.2109C0.690104 12.3047 0.854167 12.3516 1.03125 12.3516C1.29167 12.3516 1.52865 12.2448 1.74219 12.0312L8.96094 4.82031L10.2109 3.41406L10.0938 6.32812V9.27344C10.0938 9.54427 10.1823 9.77865 10.3594 9.97656C10.5417 10.1693 10.7656 10.2656 11.0312 10.2656C11.2917 10.2656 11.5182 10.1693 11.7109 9.97656C11.9036 9.78385 12 9.54427 12 9.25781Z",
    fill: "#9C9C9C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaArrow);
export default __webpack_public_path__ + "static/media/cta-arrow.bedfa1b24b744131935a2d5cda866c84.svg";
export { ForwardRef as ReactComponent };